import React, { useEffect, useState } from "react";

//interfaces
import { IPhoneData } from "./Phonenumbers.interfaces";

//hooks and services
import { getCountryDataFromCode, getLocationBestGuess } from "./PhonenumberInput.utils";

const UsePhoneNumberInput = (defaultData:IPhoneData) => {
    
    const [formData, setFormData] = useState<{countryCode: string; prefix: string; phoneNumber: string;}>({ countryCode: "", prefix: "", phoneNumber: ""});

    
    //setting default values on load
    useEffect(() => {
        if (defaultData) {
            const {location, prefix } = getLocationBestGuess()
            setFormData({ countryCode: defaultData.countryCode || location, prefix, phoneNumber: defaultData.phoneNumber || "",});
        }
    }, [defaultData]);

    //on countrycode selection
    const handleCountryCode = (value: any) => {
        const data = getCountryDataFromCode(value)
        if (data?.ISOCountryCode) {
            setFormData({ ...formData,countryCode: data.ISOCountryCode, prefix: data.dialCode,});
        }
    };

    return {hidePhoneNumberInput: !defaultData, handleCountryCode, formData, setFormData}
};

export default UsePhoneNumberInput;